import React, { useState } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import styled from 'styled-components';
import CMSSidebar from './CMSSidebar';
import PortfolioPage from './pages/PortfolioPage';
import ChatbotAIPage from './pages/ChatbotAIPage';
import ProposalMachinePage from './pages/ProposalMachinePage';

const Shell = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.bg};
  color: ${({ theme }) => theme.colors.text.primary};
  display: flex;
  align-items: stretch;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const Content = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
  padding: 36px 44px;
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;

  @media (max-width: 900px) {
    padding: 20px 16px 32px;
    max-width: 100%;
  }

  @media (max-width: 480px) {
    padding: 16px 12px 28px;
  }
`;

const CMSDashboard = () => {
  const [section, setSection] = useState('portfolio');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const auth = getAuth();

  const handleLogout = async () => {
    try { await signOut(auth); } catch (err) { console.error(err); }
  };

  return (
    <Shell>
      <CMSSidebar
        active={section}
        onChange={setSection}
        onLogout={handleLogout}
        isOpen={drawerOpen}
        onOpen={() => setDrawerOpen(true)}
        onClose={() => setDrawerOpen(false)}
      />
      <Content>
        <Main>
          {section === 'portfolio' && <PortfolioPage />}
          {section === 'chatbot' && <ChatbotAIPage />}
          {section === 'proposal' && <ProposalMachinePage />}
        </Main>
      </Content>
    </Shell>
  );
};

export default CMSDashboard;
